import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function PromoSection() {
  const [promos, setPromos] = useState([]);

  useEffect(() => {
    api.get("/promotions").then((r) => {
      setPromos((r.data || []).filter((p) => p.placement === "home" || p.placement === "both"));
    }).catch(() => {});
  }, []);

  if (promos.length === 0) return null;

  return (
    <section data-testid="home-promos" className="bg-navy text-white py-20 lg:py-24 border-t border-copper/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3">
          <Megaphone size={18} className="text-copper" />
          <span className="eyebrow text-tan">Current Offers</span>
        </div>
        <h2 className="font-serif text-4xl sm:text-5xl text-sand mt-4 leading-tight">What's happening right now.</h2>
        <div className="divider my-6 bg-tan" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {promos.map((p) => (
            <div key={p.id} data-testid={`home-promo-${p.id}`} className="float-card bg-white/5 border border-copper/25 p-7 flex flex-col">
              {p.badge && <span className="self-start bg-copper text-navy px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.2em]">{p.badge}</span>}
              <div className="font-serif text-2xl text-sand mt-4">{p.title}</div>
              {p.body && <p className="text-sm text-white/70 mt-2 leading-relaxed flex-1">{p.body}</p>}
              {p.cta_text && p.cta_url && (
                <Link to={p.cta_url} className="mt-5 inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-tan hover:text-copper">
                  {p.cta_text} <ArrowRight size={14} />
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
